/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

export function listData(params){ //get网卡分销列表
    return request({
        url: 'card/distributioncard/list.do',
        method: 'post',
        data:params
    })
}

export function getagentList(){
    return request({
        url: 'agent/list4distriagents.do?',
        method: 'post'
    })
}
export function importCardSync(params){
    return request({
        url: 'card/distributioncard/importCardSync.do?',
        method: 'post',
        data:params,
        timeout:20000,
		headers:{'Content-Type': 'multipart/form-data'}
    })
}
export function importCard(){
    return request({
        url: 'agent/importCard.do?',
        method: 'post'
    })
}

//failList.vue
export function distributioncardfail(params){
    return request({
        url: 'card/distributioncardfail/list.do?',
        method: 'post',
        data:params
    })
}
export function findById(params){
    return request({
        url: 'card/distributioncardfail/findById.do?',
        method: 'post',
        data:params
    })
}

